import LookupAttributesRequestModel from '../../../generated/types/model/request/LookupAttributesRequestModel';

export default class LookupAttributesRequestViewModel extends LookupAttributesRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
